/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_MY_PROFILE = gql`
  query GetMyProfile($input1: GetTxnListInput) {
    getMyProfile {
      vuid
      bannerImg
      bio
      email
      emailVerified
      phoneVerified
      occupation
      firstName
      fullName
      image
      kycSubmitted
      kyc {
        doc
        name
        status
        type
        comment
        fileType
      }
      address {
        addressLine1
        addressLine2
        addressLine3
        city
        country
        state
        zipcode
      }
      lastName
      primaryContactNo
    }
    getTxnList(input: $input1) {
      data {
        action
        payload
        id
        txnOwner {
          email
          firstName
          fullName
          image
          lastName
        }
        type
        when
        where
      }
      pageSize
      totalCount
      totalPages
      currentPage
    }
  }
`;
